export const dateHelper = (timestamp: number | null) => {
  let eventDate = new Date();
  if (timestamp) {
    eventDate = new Date(timestamp * 1000);
  }

  const day = `0${eventDate.getDate()}`.slice(-2);
  const hours = `0${eventDate.getHours()}`.slice(-2);
  const minutes = `0${eventDate.getMinutes()}`.slice(-2);
  const seconds = `0${eventDate.getSeconds()}`.slice(-2);
  const month = `0${eventDate.getMonth() + 1}`.slice(-2);
  const fullYear = eventDate.getFullYear();

  return {
    dateFull: `${day}.${month}.${fullYear}`,
    dateFullReverse: `${fullYear}-${month}-${day}`,
    dateFullWithSlash: `${day}/${month}/${fullYear}`,
    dateRoundUpToMidnight: new Date(fullYear, eventDate.getMonth(), eventDate.getDate()),
    dateShort: `${day}/${month}`,
    fullTime: `${hours}:${minutes}:${seconds}`,
    fullTimeDate: `${hours}:${minutes}, ${day}.${month}.${fullYear}`,
    hours,
    minutes,
    seconds,
    shortTime: `${minutes}:${seconds}`,
    time: `${hours}:${minutes}`,
  };
};
